import React, { useState, useEffect } from 'react';

const AboutPage = ({ onNavigate }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Function to handle navigation
  const handleNavigation = (page) => {
    onNavigate(page);
    setIsMenuOpen(false); // Close mobile menu after navigation
  };

  // Function to handle social media links
  const handleSocialClick = (platform) => {
    const urls = {
      twitter: 'https://twitter.com/your-university',
      facebook: 'https://facebook.com/your-university',
      pinterest: 'https://pinterest.com/your-university',
      linkedin: 'https://linkedin.com/company/your-university'
    };
    window.open(urls[platform], '_blank');
  };

  const coreValues = [
    { icon: '🎯', title: 'Integrity', desc: 'Maintaining honesty and strict ethical standards in all our endeavors.' },
    { icon: '🏆', title: 'Excellence', desc: 'Striving for high quality and continuous improvement in education.' },
    { icon: '🤝', title: 'Respect', desc: 'Valuing diversity and treating everyone with dignity and understanding.' },
    { icon: '💡', title: 'Innovation', desc: 'Encouraging creativity and fostering new ideas for progressive learning.' },
    { icon: '📋', title: 'Responsibility', desc: 'Taking accountability for our actions and their outcomes.' },
    { icon: '👥', title: 'Collaboration', desc: 'Promoting teamwork and building meaningful partnerships.' },
    { icon: '❤️', title: 'Service', desc: 'Committing to serve others and contribute to the community.' }
  ];

  const salientFeatures = [
    { icon: '🌱', title: 'Holistic Education', desc: 'Emphasizing not only academic excellence but also personal development, integrating physical, mental and spiritual growth.' },
    { icon: '⚖️', title: 'Values-based Learning', desc: 'Providing education based on ethical and moral values, promoting character formation and intellectual growth.' },
    { icon: '🔄', title: 'Innovative Curriculum', desc: 'Dynamic and relevant curriculum incorporating contemporary educational practices and research trends.' },
    { icon: '🎭', title: 'Cultural & Spiritual Enrichment', desc: 'Opportunities for students to participate in cultural activities and spiritual practices.' },
    { icon: '🤲', title: 'Community Engagement', desc: 'Involving students in community service and outreach programs for positive social contribution.' },
    { icon: '🏢', title: 'State-of-the-art Facilities', desc: 'Modern infrastructure with advanced laboratories, libraries and digital resources.' },
    { icon: '👨‍🏫', title: 'Experienced Faculty', desc: 'Dedicated and experienced educators committed to quality teaching and mentoring.' }
  ];

  const awards = [
    {
      year: '2024',
      title: 'News 18 Bangla Education Eminence Award',
      category: 'Most Promising University in Eastern India',
      date: 'June 21, 2024'
    },
    {
      year: '2024',
      title: 'Zee Education Excellence Award',
      category: 'Excellence in Academic Infrastructure & Activities',
      date: 'June 26, 2024'
    },
    {
      year: '2024',
      title: 'ABP Ananda Shiksha Samman',
      category: 'Excellence in Academic Infrastructure',
      date: 'June 27, 2024'
    },
    {
      year: '2023',
      title: 'ABP Ananda Shiksha Samman',
      category: 'Outstanding Academic Excellence',
      date: 'June 10, 2023'
    },
    {
      year: '2022',
      title: 'News 18 Bangla Education Eminence Award',
      category: 'Excellence in Academic Performance',
      date: 'May 28, 2022'
    }
  ];

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#ffffff' }}>
      {/* Header */}
      <header style={{
        backgroundColor: '#ffffff',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        position: 'sticky',
        top: 0,
        zIndex: 50
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1rem'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1rem 0'
          }}>
            {/* Logo */}
            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleNavigation('home')}>
              <img
                src="/logo.png"
                alt="Swami Vivekananda University Logo"
                style={{ width: '48px', height: '48px', objectFit: 'contain' }}
              />
              <div style={{ marginLeft: '12px' }}>
                <h1 style={{
                  fontSize: isMobile ? '16px' : '20px',
                  fontWeight: 'bold',
                  color: '#1f2937',
                  margin: 0
                }}>Swami Vivekananda</h1>
                <p style={{
                  fontSize: '14px',
                  color: '#0f766e',
                  margin: 0
                }}>University</p>
              </div>
            </div>

            {/* Desktop Navigation */}
            {!isMobile && (
              <nav style={{
                display: 'flex',
                gap: '2rem'
              }}>
                <button onClick={() => handleNavigation('home')} style={{
                  color: '#374151',
                  fontWeight: '500',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'color 0.3s',
                  position: 'relative',
                  padding: '0.5rem 0',
                  fontSize: '16px'
                }}
                onMouseEnter={(e) => e.target.style.color = '#0f766e'}
                onMouseLeave={(e) => e.target.style.color = '#374151'}>
                  Home
                </button>
                <button onClick={() => handleNavigation('about')} style={{
                  color: '#0f766e',
                  fontWeight: '500',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'color 0.3s',
                  position: 'relative',
                  padding: '0.5rem 0',
                  fontSize: '16px'
                }}
                onMouseEnter={(e) => e.target.style.color = '#059669'}
                onMouseLeave={(e) => e.target.style.color = '#0f766e'}>
                  About
                </button>
                <button onClick={() => handleNavigation('contact')} style={{
                  color: '#374151',
                  fontWeight: '500',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'color 0.3s',
                  position: 'relative',
                  padding: '0.5rem 0',
                  fontSize: '16px'
                }}
                onMouseEnter={(e) => e.target.style.color = '#0f766e'}
                onMouseLeave={(e) => e.target.style.color = '#374151'}>
                  Contact
                </button>
              </nav>
            )}

            {/* Desktop Login Button */}
            {!isMobile && (
              <button onClick={() => handleNavigation('login')} style={{
                backgroundColor: '#0f766e',
                color: 'white',
                padding: '10px 24px',
                borderRadius: '8px',
                border: 'none',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 4px rgba(15, 118, 110, 0.2)'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#0d9488';
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.boxShadow = '0 4px 8px rgba(15, 118, 110, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#0f766e';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 2px 4px rgba(15, 118, 110, 0.2)';
              }}>
                Portal Login
              </button>
            )}

            {/* Mobile Hamburger Menu */}
            {isMobile && (
              <button
                onClick={toggleMenu}
                style={{
                  width: '40px',
                  height: '40px',
                  border: 'none',
                  background: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  zIndex: 1001
                }}
              >
                <div style={{
                  width: '25px',
                  height: '3px',
                  backgroundColor: '#374151',
                  borderRadius: '3px',
                  position: 'absolute',
                  top: isMenuOpen ? '50%' : '30%',
                  left: '50%',
                  transform: `translate(-50%, -50%) ${isMenuOpen ? 'rotate(45deg)' : 'rotate(0)'}`,
                  transition: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
                }}></div>
                <div style={{
                  width: '25px',
                  height: '3px',
                  backgroundColor: '#374151',
                  borderRadius: '3px',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  opacity: isMenuOpen ? 0 : 1,
                  transition: 'all 0.3s ease'
                }}></div>
                <div style={{
                  width: '25px',
                  height: '3px',
                  backgroundColor: '#374151',
                  borderRadius: '3px',
                  position: 'absolute',
                  top: isMenuOpen ? '50%' : '70%',
                  left: '50%',
                  transform: `translate(-50%, -50%) ${isMenuOpen ? 'rotate(-45deg)' : 'rotate(0)'}`,
                  transition: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
                }}></div>
              </button>
            )}
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobile && (
          <>
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: isMenuOpen ? '20vw' : '0',
              height: '100vh',
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              zIndex: 998,
              opacity: isMenuOpen ? 1 : 0,
              visibility: isMenuOpen ? 'visible' : 'hidden',
              transition: 'all 0.3s ease',
              backdropFilter: 'blur(3px)'
            }} onClick={toggleMenu}></div>

            <div style={{
              position: 'fixed',
              top: 0,
              right: isMenuOpen ? '0' : '-100%',
              width: '80vw',
              maxWidth: '300px',
              height: '100vh',
              backgroundColor: '#ffffff',
              boxShadow: '-8px 0 32px rgba(0, 0, 0, 0.2)',
              transition: 'right 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
              zIndex: 999,
              padding: '6rem 2rem 2rem 2rem',
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)'
            }}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
              }}>
                {[
                  { name: 'Home', page: 'home' },
                  { name: 'About', page: 'about' },
                  { name: 'Contact', page: 'contact' }
                ].map((item, index) => (
                  <button
                    key={item.name}
                    onClick={() => handleNavigation(item.page)}
                    style={{
                      color: '#374151',
                      fontWeight: '600',
                      background: 'none',
                      border: 'none',
                      fontSize: '18px',
                      padding: '16px 20px',
                      borderRadius: '12px',
                      transition: 'all 0.3s ease',
                      display: 'block',
                      position: 'relative',
                      transform: isMenuOpen ? 'translateX(0)' : 'translateX(50px)',
                      opacity: isMenuOpen ? 1 : 0,
                      transitionDelay: `${index * 0.1 + 0.2}s`,
                      cursor: 'pointer',
                      textAlign: 'left',
                      width: '100%'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = '#0f766e';
                      e.target.style.backgroundColor = '#f0fdfa';
                      e.target.style.transform = 'translateX(10px)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = '#374151';
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.transform = 'translateX(0)';
                    }}
                  >
                    {item.name}
                    <span style={{
                      position: 'absolute',
                      right: '20px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      fontSize: '20px',
                      opacity: 0.5
                    }}>→</span>
                  </button>
                ))}
                
                {/* Portal Login Button with Green Container */}
                <button
                  onClick={() => handleNavigation('login')}
                  style={{
                    color: 'white',
                    fontWeight: '600',
                    backgroundColor: '#0f766e',
                    border: 'none',
                    fontSize: '18px',
                    padding: '16px 20px',
                    borderRadius: '12px',
                    transition: 'all 0.3s ease',
                    display: 'block',
                    position: 'relative',
                    transform: isMenuOpen ? 'translateX(0)' : 'translateX(50px)',
                    opacity: isMenuOpen ? 1 : 0,
                    transitionDelay: `${3 * 0.1 + 0.2}s`,
                    cursor: 'pointer',
                    textAlign: 'left',
                    width: '100%',
                    boxShadow: '0 4px 12px rgba(15, 118, 110, 0.3)',
                    marginTop: '8px'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#0d9488';
                    e.target.style.transform = 'translateX(10px)';
                    e.target.style.boxShadow = '0 6px 16px rgba(15, 118, 110, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#0f766e';
                    e.target.style.transform = 'translateX(0)';
                    e.target.style.boxShadow = '0 4px 12px rgba(15, 118, 110, 0.3)';
                  }}
                >
                  Portal Login
                  <span style={{
                    position: 'absolute',
                    right: '20px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    fontSize: '20px',
                    opacity: 0.8
                  }}>→</span>
                </button>
              </div>
            </div>
          </>
        )}
      </header>

      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #f0fdfa 0%, #dcfce7 50%, #e6fffa 100%)',
        padding: isMobile ? '4rem 0' : '6rem 0',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: '-50px',
          right: '-50px',
          width: '200px',
          height: '200px',
          background: 'linear-gradient(45deg, rgba(15, 118, 110, 0.1), rgba(5, 150, 105, 0.1))',
          borderRadius: '50%',
          filter: 'blur(40px)'
        }}></div>
        
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1rem',
          position: 'relative'
        }}>
          <div style={{ textAlign: 'center' }}>
            <h1 style={{
              fontSize: isMobile ? '2.5rem' : '4rem',
              fontWeight: 'bold',
              color: '#1f2937',
              marginBottom: '1.5rem',
              lineHeight: '1.2'
            }}>
              About <span style={{ 
                color: '#0f766e',
                background: 'linear-gradient(135deg, #0f766e, #059669)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>Swami Vivekananda</span> University
            </h1>
            <p style={{
              fontSize: isMobile ? '1.1rem' : '1.25rem',
              color: '#374151',
              marginBottom: '3rem',
              maxWidth: '900px',
              margin: '0 auto 3rem auto',
              lineHeight: '1.6'
            }}>
              Founded with the vision to promote holistic education inspired by the teachings of Swami Vivekananda, we are committed to academic excellence, student development, and community involvement.
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section id="mission" style={{ 
        padding: isMobile ? '4rem 0' : '6rem 0', 
        backgroundColor: '#ffffff' 
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1rem'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
            gap: '3rem',
            alignItems: 'center'
          }}>
            <div>
              <h2 style={{
                fontSize: isMobile ? '2.5rem' : '3rem',
                fontWeight: 'bold',
                color: '#1f2937',
                marginBottom: '2rem'
              }}>Our Mission</h2>
              <p style={{
                fontSize: isMobile ? '16px' : '18px',
                color: '#374151',
                lineHeight: '1.8',
                marginBottom: '1.5rem'
              }}>
                Our mission is primarily focused on providing quality education, promoting intellectual growth, and preparing students for successful careers. We emphasize a commitment to academic excellence, student development, and community involvement.
              </p>
              <p style={{
                fontSize: isMobile ? '16px' : '18px',
                color: '#374151',
                lineHeight: '1.8'
              }}>
                Our clear and compelling mission statement helps align the institution's efforts and resources toward a common goal, ensuring that all members understand and work toward the same objectives while building a strong brand and garnering community support.
              </p>
            </div>
            <div style={{
              backgroundColor: '#f0fdfa',
              borderRadius: '20px',
              padding: '3rem',
              textAlign: 'center',
              border: '2px solid #ccfbf1'
            }}>
              <div style={{
                width: '120px',
                height: '120px',
                backgroundColor: '#0f766e',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 2rem auto',
                boxShadow: '0 10px 30px rgba(15, 118, 110, 0.3)'
              }}>
                <span style={{ fontSize: '48px', color: 'white' }}>🎯</span>
              </div>
              <h3 style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#0f766e',
                marginBottom: '1rem'
              }}>Quality Education</h3>
              <p style={{
                color: '#374151',
                fontSize: '16px',
                lineHeight: '1.6'
              }}>
                Dedicated to fostering intellectual growth and preparing students for successful careers through academic excellence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section id="vision" style={{ 
        padding: isMobile ? '4rem 0' : '6rem 0', 
        backgroundColor: '#f9fafb' 
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1rem'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
            gap: '3rem',
            alignItems: 'center'
          }}>
            <div style={{
              backgroundColor: '#ffffff',
              borderRadius: '20px',
              padding: '3rem',
              textAlign: 'center',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
              border: '2px solid #e5e7eb'
            }}>
              <div style={{
                width: '120px',
                height: '120px',
                background: 'linear-gradient(135deg, #0f766e, #059669)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 2rem auto',
                boxShadow: '0 10px 30px rgba(15, 118, 110, 0.3)'
              }}>
                <span style={{ fontSize: '48px', color: 'white' }}>🔮</span>
              </div>
              <h3 style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#0f766e',
                marginBottom: '1rem'
              }}>Global Excellence</h3>
              <p style={{
                color: '#374151',
                fontSize: '16px',
                lineHeight: '1.6'
              }}>
                Aspiring to be a leading institution contributing to knowledge advancement and social development.
              </p>
            </div>
            <div>
              <h2 style={{
                fontSize: isMobile ? '2.5rem' : '3rem',
                fontWeight: 'bold',
                color: '#1f2937',
                marginBottom: '2rem'
              }}>Our Vision</h2>
              <p style={{
                fontSize: isMobile ? '16px' : '18px',
                color: '#374151',
                lineHeight: '1.8',
                marginBottom: '1.5rem'
              }}>
                To be a leading institution of higher education that contributes significantly to the advancement of knowledge, research and social development. We aim to provide a world-class educational experience that promotes intellectual growth, innovation and leadership.
              </p>
              <p style={{
                fontSize: isMobile ? '16px' : '18px',
                color: '#374151',
                lineHeight: '1.8'
              }}>
                We see ourselves as a center of academic excellence and a cutting-edge research center addressing current global challenges while maintaining our reputation as a renowned institution with a global perspective.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section id="values" style={{ 
        padding: isMobile ? '4rem 0' : '6rem 0', 
        backgroundColor: '#ffffff' 
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1rem'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontSize: isMobile ? '2.5rem' : '3rem',
              fontWeight: 'bold',
              color: '#1f2937',
              marginBottom: '1rem'
            }}>Our Core Values</h2>
            <p style={{
              fontSize: isMobile ? '18px' : '20px',
              color: '#6b7280',
              maxWidth: '700px',
              margin: '0 auto'
            }}>
              Fundamental principles that define our identity and guide our actions, decisions, and interactions, serving as our moral compass.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem'
          }}>
            {coreValues.map((value, index) => (
              <div key={index} style={{
                backgroundColor: '#f8fafc',
                borderRadius: '16px',
                padding: '2rem',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                border: '2px solid #e2e8f0',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f0fdfa';
                e.currentTarget.style.borderColor = '#0f766e';
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(15, 118, 110, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f8fafc';
                e.currentTarget.style.borderColor = '#e2e8f0';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}>
                <div style={{
                  width: '80px',
                  height: '80px',
                  backgroundColor: '#ccfbf1',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1.5rem auto'
                }}>
                  <span style={{ fontSize: '36px' }}>{value.icon}</span>
                </div>
                <h3 style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#1f2937',
                  marginBottom: '12px'
                }}>{value.title}</h3>
                <p style={{ color: '#6b7280', lineHeight: '1.6', fontSize: '14px' }}>{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Salient Features Section */}
      <section style={{ 
        padding: isMobile ? '4rem 0' : '6rem 0', 
        backgroundColor: '#f9fafb' 
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1rem'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontSize: isMobile ? '2.5rem' : '3rem',
              fontWeight: 'bold',
              color: '#1f2937',
              marginBottom: '1rem'
            }}>Salient Features</h2>
            <p style={{
              fontSize: isMobile ? '18px' : '20px',
              color: '#6b7280',
              maxWidth: '700px',
              margin: '0 auto'
            }}>
              Distinctive characteristics that reflect our commitment to educating well-rounded individuals who are academically competent, socially responsible, and ethically sound.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '2rem'
          }}>
            {salientFeatures.map((feature, index) => (
              <div key={index} style={{
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                padding: '2rem',
                transition: 'all 0.3s ease',
                border: '1px solid rgba(15, 118, 110, 0.1)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.15)';
                e.currentTarget.style.borderColor = '#0f766e';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)';
                e.currentTarget.style.borderColor = 'rgba(15, 118, 110, 0.1)';
              }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: '#ccfbf1',
                  borderRadius: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1.5rem'
                }}>
                  <span style={{ fontSize: '28px' }}>{feature.icon}</span>
                </div>
                <h3 style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#1f2937',
                  marginBottom: '12px'
                }}>{feature.title}</h3>
                <p style={{ color: '#6b7280', lineHeight: '1.6', fontSize: '15px' }}>{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Recognition Section */}
      <section style={{ 
        padding: isMobile ? '4rem 0' : '6rem 0', 
        backgroundColor: '#ffffff' 
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1rem'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontSize: isMobile ? '2.5rem' : '3rem',
              fontWeight: 'bold',
              color: '#1f2937',
              marginBottom: '1rem'
            }}>Recognition & Affiliations</h2>
            <p style={{
              fontSize: isMobile ? '18px' : '20px',
              color: '#6b7280',
              maxWidth: '700px',
              margin: '0 auto'
            }}>
              Officially recognized and accredited by government authorities, ensuring quality education standards.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem',
            marginBottom: '4rem'
          }}>
            {[
              { 
                icon: '🏛️', 
                title: 'UGC Recognized', 
                desc: 'Recognized by University Grants Commission (UGC) for maintaining educational standards.',
                color: '#0f766e'
              },
              { 
                icon: '📜', 
                title: 'Government Approved', 
                desc: 'Approved by Department of Higher Education, West Bengal since December 5, 2019.',
                color: '#059669'
              },
              { 
                icon: '⚖️', 
                title: 'Legislative Support', 
                desc: 'Swami Vivekananda University Bill, 2019 passed by West Bengal Legislative Assembly.',
                color: '#0d9488'
              }
            ].map((item, index) => (
              <div key={index} style={{
                backgroundColor: '#f8fafc',
                borderRadius: '16px',
                padding: '2rem',
                textAlign: 'center',
                border: `2px solid ${item.color}20`,
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = `${item.color}10`;
                e.currentTarget.style.borderColor = item.color;
                e.currentTarget.style.transform = 'translateY(-5px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f8fafc';
                e.currentTarget.style.borderColor = `${item.color}20`;
                e.currentTarget.style.transform = 'translateY(0)';
              }}>
                <div style={{
                  width: '80px',
                  height: '80px',
                  backgroundColor: `${item.color}20`,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1.5rem auto'
                }}>
                  <span style={{ fontSize: '36px' }}>{item.icon}</span>
                </div>
                <h3 style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: item.color,
                  marginBottom: '12px'
                }}>{item.title}</h3>
                <p style={{ color: '#6b7280', lineHeight: '1.6' }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Awards Section */}
      <section id="awards" style={{ 
        padding: isMobile ? '4rem 0' : '6rem 0', 
        background: 'linear-gradient(135deg, #1f2937 0%, #111827 100%)', 
        color: 'white' 
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1rem'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontSize: isMobile ? '2.5rem' : '3rem',
              fontWeight: 'bold',
              marginBottom: '1rem'
            }}>Awards & Recognition</h2>
            <p style={{
              fontSize: isMobile ? '18px' : '20px',
              color: '#d1d5db',
              maxWidth: '700px',
              margin: '0 auto'
            }}>
              Prestigious awards recognizing our commitment to excellence, innovation, and leadership in education.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '2rem'
          }}>
            {awards.map((award, index) => (
              <div key={index} style={{
                backgroundColor: 'rgba(55, 65, 81, 0.5)',
                borderRadius: '16px',
                padding: '2rem',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(94, 234, 212, 0.2)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(15, 118, 110, 0.1)';
                e.currentTarget.style.borderColor = '#5eead4';
                e.currentTarget.style.transform = 'translateY(-5px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(55, 65, 81, 0.5)';
                e.currentTarget.style.borderColor = 'rgba(94, 234, 212, 0.2)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '1rem'
                }}>
                  <span style={{
                    backgroundColor: '#0f766e',
                    color: 'white',
                    padding: '6px 12px',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: 'bold'
                  }}>{award.year}</span>
                  <span style={{ fontSize: '24px' }}>🏆</span>
                </div>
                <h3 style={{
                  fontSize: '18px',
                  fontWeight: 'bold',
                  color: '#5eead4',
                  marginBottom: '8px'
                }}>{award.title}</h3>
                <p style={{
                  color: '#d1d5db',
                  marginBottom: '8px',
                  fontSize: '16px'
                }}>{award.category}</p>
                <p style={{
                  color: '#9ca3af',
                  fontSize: '14px'
                }}>{award.date}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section style={{ 
        padding: isMobile ? '4rem 0' : '6rem 0', 
        backgroundColor: '#f0fdfa',
        textAlign: 'center'
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          padding: '0 1rem'
        }}>
          <h2 style={{
            fontSize: isMobile ? '2rem' : '2.5rem',
            fontWeight: 'bold',
            color: '#1f2937',
            marginBottom: '1.5rem'
          }}>Ready to Join Our Community?</h2>
          <p style={{
            fontSize: isMobile ? '16px' : '18px',
            color: '#374151',
            marginBottom: '2rem',
            lineHeight: '1.6'
          }}>
            Discover the opportunities that await you at Swami Vivekananda University. Explore our programs, visit our campus, and take the first step towards your future.
          </p>
          <div style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: '1rem',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <button style={{
              backgroundColor: '#0f766e',
              color: 'white',
              padding: '14px 32px',
              borderRadius: '12px',
              border: 'none',
              fontWeight: '600',
              fontSize: '16px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              width: isMobile ? '100%' : 'auto',
              maxWidth: isMobile ? '300px' : 'none'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#0d9488';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#0f766e';
              e.target.style.transform = 'translateY(0)';
            }}>
              Explore Programs
            </button>
            <button onClick={() => handleNavigation('contact')} style={{
              border: '2px solid #0f766e',
              color: '#0f766e',
              backgroundColor: 'white',
              padding: '14px 32px',
              borderRadius: '12px',
              fontWeight: '600',
              fontSize: '16px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              width: isMobile ? '100%' : 'auto',
              maxWidth: isMobile ? '300px' : 'none'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#0f766e';
              e.target.style.color = 'white';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.color = '#0f766e';
              e.target.style.transform = 'translateY(0)';
            }}>
              Contact Us
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ 
        backgroundColor: '#111827', 
        color: '#d1d5db', 
        padding: '3rem 0 2rem 0' 
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1rem'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '2rem'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleNavigation('home')}>
              <img
                src="/logo.png"
                alt="SVU Logo"
                style={{ width: '40px', height: '40px', objectFit: 'contain' }}
              />
              <div style={{ marginLeft: '12px' }}>
                <h3 style={{
                  fontSize: '18px',
                  fontWeight: 'bold',
                  color: 'white',
                  margin: 0
                }}>Swami Vivekananda</h3>
                <p style={{ fontSize: '14px', margin: 0 }}>University</p>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '1rem' }}>
              {[
                { platform: 'twitter', path: 'M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z' },
                { platform: 'facebook', path: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' },
                { platform: 'linkedin', path: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' }
              ].map(social => (
                <button
                  key={social.platform}
                  onClick={() => handleSocialClick(social.platform)}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px',
                    border: '1px solid #374151',
                    backgroundColor: 'transparent',
                    color: '#9ca3af',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.borderColor = '#5eead4';
                    e.target.style.backgroundColor = '#5eead4';
                    e.target.style.color = '#1f2937';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.borderColor = '#374151';
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#9ca3af';
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d={social.path} />
                  </svg>
                </button>
              ))}
            </div>
          </div>

          <div style={{
            borderTop: '1px solid #374151',
            paddingTop: '2rem',
            marginTop: '2rem',
            textAlign: 'center'
          }}>
            <p style={{ fontSize: '14px', margin: 0, opacity: 0.8 }}>
              &copy; 2025 Swami Vivekananda University. All rights reserved. | UGC Recognized Private University
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutPage;